import { Content } from 'src/contexts/ContentContext';
import { ContentPlaceholder } from 'src/core/POS/ContentPlaceholder';
import { vars } from 'src/core/themes';
import { Stack } from 'src/core/ui';
import { ContentId } from 'src/utils/constants/contentId';

export const PlaceHolderZoneGroup = () => {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      width="full"
      style={{
        flex: 1,
        padding: '40px 0',
        border: `1px solid ${vars.color.border}`,
        borderRadius: vars.borderRadius.m,
      }}
    >
      <Stack direction="column" gap="m" style={{ width: '40%' }}>
        <Stack
          alignItems="center"
          justifyContent="center"
          width="full"
          style={{
            padding: vars.spacing.xxl,
            border: `1px solid ${vars.color.borderLight}`,
            borderRadius: vars.borderRadius.m,
          }}
        >
          <div
            style={{
              width: '75%',
              fontSize: vars.typography.fontSize.xl,
              textAlign: 'center',
              color: vars.color.textDisabled,
            }}
          >
            <Content id={ContentId.ZoneGroupInstruction} />
          </div>
        </Stack>
        <ContentPlaceholder solidBackground width="100%" height="6rem" />
        <ContentPlaceholder solidBackground width="100%" height="3rem" />
        <ContentPlaceholder solidBackground width="100%" height="2rem" />
      </Stack>
    </Stack>
  );
};
